export default function LoadingSpinner({ fullScreen = false, message = 'Loading...' }) {
  if (fullScreen) {
    return (
      <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col items-center justify-center gap-4">
        <div className="w-10 h-10 border-2 border-gray-200 dark:border-white/10 border-t-green-500 rounded-full animate-spin" />
        <div className="text-gray-500 text-xs uppercase tracking-widest">
          {message}
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4">
      <div className="w-8 h-8 border-2 border-gray-200 dark:border-white/10 border-t-green-500 rounded-full animate-spin" />
      <div className="text-gray-500 text-xs uppercase tracking-widest">
        {message}
      </div>
    </div>
  )
}